import Icon from '../components/Icon.vue'

Icon.register({
  newspaper: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M552 64c13.3 0 24 10.7 24 24v312c0 26.5-21.5 48-48 48h-472c-30.9 0-56-25.1-56-56v-272c0-13.3 10.7-24 24-24h40v-8c0-13.3 10.7-24 24-24h464zM56 400c4.4 0 8-3.6 8-8v-248h-16v248c0 4.4 3.6 8 8 8zM292 384c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-152c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h152zM500 384c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-152c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h152zM292 288c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-152c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h152zM500 288c6.6 0 12-5.4 12-12v-8c0-6.6-5.4-12-12-12h-152c-6.6 0-12 5.4-12 12v8c0 6.6 5.4 12 12 12h152zM500 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-360c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h360z'
      }
    ]
  }
})
